import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { NE_DISPLAY_SWITCHES } from 'domains/NuvemEnvioCommons/constants';
import {
  acceptNuvemEnvioWelcomeCreditPromotionAction,
  nuvemEnvioDisplaySwitchesAction,
  updateNuvemEnvioConfigsAction,
  updateNuvemEnvioConfigsStatus,
} from '../../deliveryMethodsSlice';

type NuvemEnvioConfigsType = {
  enableEngagementBanner?: boolean;
};

function useUpdateNuvemEnvioConfigs() {
  const dispatch = useAppDispatch();

  const status = useSelector(updateNuvemEnvioConfigsStatus);

  const updateNuvemEnvioConfigs = useCallback(
    async (payload: NuvemEnvioConfigsType) =>
      await dispatch(updateNuvemEnvioConfigsAction(payload)),
    [dispatch],
  );

  const acceptNuvemEnvioWelcomeCreditPromotion = useCallback(
    async (payload: string) =>
      await dispatch(acceptNuvemEnvioWelcomeCreditPromotionAction(payload)),
    [dispatch],
  );

  const updateNuvemEnvioDisplaySwitches = useCallback(
    async (payload: NE_DISPLAY_SWITCHES) =>
      await dispatch(nuvemEnvioDisplaySwitchesAction(payload)).unwrap(),
    [dispatch],
  );

  return {
    status,
    updateNuvemEnvioConfigs,
    acceptNuvemEnvioWelcomeCreditPromotion,
    updateNuvemEnvioDisplaySwitches,
  };
}

export default useUpdateNuvemEnvioConfigs;
